import { render, staticRenderFns } from "./section-compare.vue?vue&type=template&id=31345d86&scoped=true&"
import script from "./section-compare.vue?vue&type=script&lang=js&"
export * from "./section-compare.vue?vue&type=script&lang=js&"
import style0 from "./section-compare.vue?vue&type=style&index=0&id=31345d86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31345d86",
  null
  
)

export default component.exports